import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { addEventListener, debounce } from '@ifeng-fe/ui_base';
import LoginBtn from '../loginBtn';

/**
 * for this page
 */
// import Content from './content/';

class LoginBar extends React.PureComponent {
    static propTypes = {
        windowHeight: PropTypes.number,
        openModal: PropTypes.func
    };

    unlistenerHandleWindowScroll = null;
    state = {
        windowHeight: this.props.windowHeight,
        isDisplay: false,
        top: '',
    };

    componentDidMount() {
        const { windowHeight } = this.state;
        const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        if (scroll >= windowHeight) {
            this.setState({
                top: styles.top_show,
                isDisplay: true,
            });
        }
        this.unlistenerHandleWindowScroll = addEventListener(window, 'scroll', this.handleWindowScroll, 200);
    }
    componentWillUnmount() {
        this.unlistenerHandleWindowScroll();
    }

    handleWindowScroll = event => {
        const { windowHeight } = this.state;
        const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const isDisplay = scroll >= windowHeight;

        if (isDisplay !== this.state.isDisplay) {
            this.setState({
                // opacity: isDisplay ? styles.opacity_0_to_1 : styles.opacity_1_to_0,
                top: isDisplay ? styles.top_show : '',
                isDisplay,
            });
        }
    };

    static getDerivedStateFromProps = (props, state) => {
        let resWHeight = {};

        if (props.windowHeight !== state.windowHeight) {
            resWHeight = { windowHeight: props.windowHeight };
        }

        return { ...resWHeight };
    };

    render() {
        /**
         * 组件分发数据
         */
        const { windowHeight, top } = this.state;

        return (
            <div className={`${styles.loginBar} ${top}`}>
                <h1 className={styles.logoBox} />
                <div className={`${styles.btnWrapper} clearfix`}>
                    <span className={styles.register} onClick={this.props.openModal}>
                        注册
                    </span>
                    <LoginBtn configClass={styles.login} txt={'登录'} openModal={this.props.openModal} />
                </div>
                {/* </div> */}
            </div>
        );
    }
}

export default errorBoundary(LoginBar);
